export default __webpack_public_path__ + "static/media/1831.b46d854b.png";